function ajax() {
    const name = $(".feedback input[name='name']");
    const tel = $(".feedback input[name='tel']");
    const mail = $(".feedback input[name='mail']");
    const message = $(".feedback textarea[name='message']");
    $(".feedback button").click(function() {
        if (name.val() && tel.val() && mail.val() && message.val()) {
            name.val("");
            tel.val("");
            mail.val("");
            message.val("");
            alert("提交数据成功！");
            return false;
        } else {
            alert("请填写完整信息！");
            return false;
        }
        
    });

}

module.exports = ajax;


// WEBPACK FOOTER //
// ./js/ajax/ajax.js